<template>
  <a v-if="externalLink" :id="`application-card-${id}`" class="application-card" :href="externalLink.uri" target="_blank">
    <img v-if="buttonUsesEsl" class="application-card__esl-image" src="/themes/custom/education_applications_theme/assets/images/esl_card_icon.svg" alt="Uses ESL" width="52">
    <div class="application-card__content">
      <h3 class="application-card__title">{{ title }}</h3>
      <span class="application-card__description">{{ description }}</span>
      <div class="application-card__footer">
        <svg class="application-card__footer-arrow" xmlns="http://www.w3.org/2000/svg" width="20.707" height="20.707" viewBox="0 0 20.707 20.707">
            <path class="application-card__footer-arrow__inactive" id="external_link_icon" data-name="external link icon" d="M21.406,21.406H5.3V5.3h8.053V3H5.3A2.3,2.3,0,0,0,3,5.3V21.406a2.3,2.3,0,0,0,2.3,2.3H21.406a2.308,2.308,0,0,0,2.3-2.3V13.354h-2.3ZM15.654,3V5.3h4.13L8.476,16.609,10.1,18.231,21.406,6.923v4.13h2.3V3Z" transform="translate(-3 -3)" fill="#ffd444"/>
            <path class="application-card__footer-arrow__active" id="external_link_icon" data-name="external link icon" d="M21.406,21.406H5.3V5.3h8.053V3H5.3A2.3,2.3,0,0,0,3,5.3V21.406a2.3,2.3,0,0,0,2.3,2.3H21.406a2.308,2.308,0,0,0,2.3-2.3V13.354h-2.3ZM15.654,3V5.3h4.13L8.476,16.609,10.1,18.231,21.406,6.923v4.13h2.3V3Z" transform="translate(-3 -3)" fill="#1470E1"/>
          </svg>
  
      </div>
    </div>
  </a>
  <a v-else :id="`application-card-${id}`" class="application-card" :href="cardLink">
    <img v-if="buttonUsesEsl" class="application-card__esl-image" src="/themes/custom/education_applications_theme/assets/images/esl_card_icon.svg" alt="Uses ESL" width="52">
    <div class="application-card__content">
      <h3 class="application-card__title">{{ title }}</h3>
      <span class="application-card__description">{{ description }}</span>
      <div class="application-card__footer">
        <svg class="application-card__footer-arrow" xmlns="http://www.w3.org/2000/svg" width="21.711" height="15.299" viewBox="0 0 21.711 15.299">
                <g class="application-card__footer-arrow__inactive" id="Group_4291" data-name="Group 4291" transform="translate(1 1.412)">
                  <line id="Line_112" data-name="Line 112" x2="19.707" transform="translate(0 6.302)" fill="none" stroke="#FCB135" stroke-linecap="round" stroke-width="2"/>
                  <path id="Path_3061" data-name="Path 3061" d="M-5368.9,808.767l3.275,3.649,2.36,2.63-5.635,6.195" transform="translate(5382.977 -808.767)" fill="none" stroke="#FCB135" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                </g>
                <g class="application-card__footer-arrow__active" id="Group_4291" data-name="Group 4291" transform="translate(1 1.412)">
                  <line id="Line_112" data-name="Line 112" x2="19.707" transform="translate(0 6.302)" fill="none" stroke="#1470E1" stroke-linecap="round" stroke-width="2"/>
                  <path id="Path_3061" data-name="Path 3061" d="M-5368.9,808.767l3.275,3.649,2.36,2.63-5.635,6.195" transform="translate(5382.977 -808.767)" fill="none" stroke="#1470E1" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                </g>
              </svg>
      </div>
    </div>
  </a>
</template>

<script>
  import Vue from 'vue';
  
  export default {
    name: 'ApplicationCard',
    components: {},
    props: {
      id: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        required: false,
      },
      cardLink: {
        type: String,
        required: true,
      },
      externalLink: {
        type: Object,
        required: false,
      },
      buttonUsesEsl: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        active: false,
      };
    },
    methods: {
      formatUri(uri) {
        return uri.includes('/') ? uri.split('/').filter((pathSection) => pathSection !== '')[1] : uri;
      },
    },
  };
</script>

<style scoped lang="scss">
  .application-card {
    display: flex;
    flex-direction: column;
    /* stylelint-disable-next-line unit-blacklist */
    box-shadow: 0 3px 6px #0000002F;
    background-color: $color-white;
    border-radius: $border-radius-medium;
    border-bottom: 0.75rem $color-purple-medium solid;
    overflow: hidden;
    min-height: 16rem;
    height: 100%;
    transition: 0.3s;
    color: $color-charcoal-mid;
    @include hover-focus-active {
      color: $color-charcoal-mid;
      opacity: 0.8;
      border-bottom: 0.75rem $color-yellow solid;
      transform: translate(0%, -2%);
      transition: ease-in-out 0.3s;
      text-decoration: none;
      .application-card__footer {
        &-arrow {
          transform: translateX(3px);
        }
        &-arrow__inactive {
          visibility: hidden;
        }
        &-arrow__active {
          visibility: visible;
        }
      }
    }
    .content & {
      border-bottom: none;
    }
    &__image {
      background-color: $color-light-grey;
      border-bottom: gap-size(0.28) $color-yellow solid;
    }
    &__content {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      padding: 2rem 1.5rem 1rem;
    }
    &__title {
      font-size: $font-size-standard;
      font-weight: $font-weight-bold;
      max-width: 90%;
    }
    &__description {
      font-size: $font-size-xsmall;
      max-width: 90%;
    }
    &__footer {
      align-self: flex-end;
      margin-top: auto;
    }
    &__footer-arrow__active {
      visibility: hidden;
    }
    &__esl-image {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  
  .application-card:visited {
    color: $color-charcoal-mid !important;
    @include hover-focus-active {
      color: $color-charcoal-mid !important;
    }
  }
</style>
